import { IconName } from '@fortawesome/fontawesome-common-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { uniqueId } from 'lodash'
import React, { FC, useState } from 'react'
import { replaceAndStrip } from '../../../utils/string'
import SuggestionChips from './SuggestionChips'

type TargetItem = {
  value: string
  label: string
  color: string
  icon: IconName
}

type Suggestion = {
  values: string[]
  legendBackground?: string
}

type FilePathConditionProps = {
  targetItem: TargetItem
  paths: string[]
  onPathsChange: (paths: string[]) => void
  suggestion?: Suggestion
}

const FilePathCondition: FC<FilePathConditionProps> = (props) => {
  const {
    targetItem,
    paths,
    onPathsChange,
    suggestion,
  } = props

  const [pathText, setPathText] = useState<string>("")

  const addPath = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.nativeEvent.isComposing || e.key !== "Enter") return

    const trimValue = replaceAndStrip(pathText)
    if (!trimValue || paths.includes(trimValue)) return

    onPathsChange([...paths, trimValue])
    setPathText("")
  }

  const blurPath = (path: string) => {
    setPathText("")
    const trimValue = replaceAndStrip(path)
    if (!trimValue || paths.includes(trimValue)) return
    onPathsChange([...paths, trimValue])
  }

  return (
    <>
      <div className="condition_header">
        <div className="condition_label">
          <FontAwesomeIcon
            icon={['fas', targetItem.icon as IconName]}
            style={{ color: targetItem.color }}
          />
          {targetItem.label}
        </div>
      </div>
      <div>
        <div className="detail_box">
          {
            paths.map((path) => (
              <div className="chip" key={uniqueId()}>
                {path}
                <span className="chip_remove" onClick={() => onPathsChange(paths.filter((w) => w !== path))} role="none">
                  <FontAwesomeIcon icon={['fas', 'times']} />
                </span>
              </div>
            ))
          }
          <input
            className="keyword_input"
            type="text"
            value={pathText}
            onChange={(e) => setPathText(e.target.value)}
            onKeyDown={(e) => addPath(e)}
            onBlur={(e) => blurPath(e.target.value)}
            placeholder={paths.length ? "" : "ファイルパス(例:¥¥192.168.1.1¥user¥など)を入力してエンターキーを押してください"}
          />
        </div>
      </div>
      <div>
        <div className="note_list">
          <div className="note">
            ※ Windows OS、かつ、Word・Excel・PowerPointの作業のみファイルパスが取得可能です。
          </div>
          <div className="note">
            {`※ 指定ファイルパス${paths.length > 1 ? "のいずれか" : ""}が含まれている場合、自動仕分けされます。`}
          </div>
          <div className="note">
            ※ スペースや記号についても、含んだ状態のまま設定されます。ご注意ください。
          </div>
        </div>
      </div>
      {
        !!suggestion?.values.length && (
          <SuggestionChips
            values={suggestion.values}
            selectedValues={paths}
            onToggle={(v) => onPathsChange(
              paths.includes(v) ? paths.filter((p) => p !== v) : [...paths, v],
            )}
            legendBackground={suggestion.legendBackground}
          />
        )
      }
    </>
  )
}

export default FilePathCondition
